module.exports = __webpack_public_path__ + "static/media/ca_phe_hanoi.64cfa0df.webp";